module.exports = __webpack_public_path__ + "static/img/nuclear-waste_256.d62f5a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/nuclear-waste_256.png
// module id = 7Sua
// module chunks = 0